const t = `<?xml version="1.0" encoding="utf-8"?>
<svg width="800px" height="800px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
<title>globe</title>
<path d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,18c-.61-.24-2-2.63-2.23-7h4.46C12,15.36,10.61,17.75,10,18ZM10,2c.61.24,2,2.63,2.23,7H7.77C8,4.64,9.39,2.25,10,2Zm7.93,7h-3.7a17.17,17.17,0,0,0-1.42-6.48A8,8,0,0,1,17.93,9ZM7.19,2.52A17.17,17.17,0,0,0,5.77,9H2.07A8,8,0,0,1,7.19,2.52ZM2.07,11h3.7a17.17,17.17,0,0,0,1.42,6.48A8,8,0,0,1,2.07,11Zm10.74,6.48A17.17,17.17,0,0,0,14.23,11h3.7A8,8,0,0,1,12.81,17.48Z"/>
</svg>`;
export {
  t as default
};
